import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    wrap: {
        background: '#192444',
        borderRadius: '4px',
        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 50%), inset 0 1px 0 0 #31406d',
        width: 150,
        height: 150,
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        fontSize: '20px',
        cursor: 'pointer',
     
    },
    label: {
        fontSize: 18,
        fontWeight: 700,
        color: '#fff',
        textAlign:'center',
        userSelect: 'none',
    },
    name: {
        fontSize: 16,
        fontWeight: 700,
        color: '#fff',
        textAlign:'center',
        padding: 15,
        userSelect: 'none',
    }
}))

const ItemBonus = ({name, label, event}) => {
    const classes = useStyles();

    return (
        <div 
            className={classes.wrap}
            onClick={() => event()}>
            {
                !!label &&
                <span className={classes.label}>
                    {label}
                </span>
            }
            
            <span className={classes.name}>
                {name}
            </span>
        </div>
    )
}

export default ItemBonus;